import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Slide,
    Grid,
    Typography,
    Box,
    Chip,
    Paper
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { dateV2, formatDateWithTime } from '../utils/DateUtils'
import { reportsRoutes } from '../routes'

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const getTimestampFromObjectIdOrDate = (dateVal, mongoId) => {
    if (dateVal) {
        const d = new Date(dateVal)
        if (!isNaN(d.getTime())) return d
    }
    if (mongoId) {
        try {
            const hex = typeof mongoId === 'object' ? mongoId.toString() : String(mongoId)
            if (hex && hex.length === 24) {
                return new Date(parseInt(hex.substring(0, 8), 16) * 1000)
            }
        } catch (e) {
            // ignore error
        }
    }
    return null
}

const getUserDisplayName = (userObj) => {
    if (!userObj) return 'No registrado'
    if (typeof userObj === 'string') return userObj
    const nameParts = [userObj.name, userObj.lastName].filter(Boolean)
    if (nameParts.length > 0) return nameParts.join(' ')
    return userObj.email || userObj.username || String(userObj._id || 'Usuario')
}

const ReportDetailDialog = ({ handleClickOpen, open, handleClose, report = {} }) => {
    const navigate = useNavigate()

    if (!report) return null

    const createdByName = getUserDisplayName(report.createdBy)
    const createdDate = getTimestampFromObjectIdOrDate(
        report.createdAt,
        (report.createdBy && typeof report.createdBy === 'object' ? report.createdBy._id : null) || report._id
    )

    const updatedByName = getUserDisplayName(report.updatedBy || report.createdBy)
    const updatedDate = getTimestampFromObjectIdOrDate(
        report.fechaActualizacion || report.updatedAt,
        (report.updatedBy && typeof report.updatedBy === 'object' ? report.updatedBy._id : null) || report._id
    )

    const handleViewPdf = async () => {
        if (report._id) {
            try {
                const res = await reportsRoutes.getPdfUrl(report._id)
                if (res?.data?.url) {
                    window.open(res.data.url, '_blank')
                    return
                }
            } catch (err) {
                console.error('Error fetching PDF:', err)
            }
        }
        if (report.urlPdf) {
            window.open(report.urlPdf, '_blank')
        } else {
            alert('PDF no disponible para este reporte.')
        }
    }

    const otNumber = report.newIdIndex || report.idIndex || 'S/I'

    const getStatusColor = (state) => {
        switch (state) {
            case 'Completada':
            case 'Completadas':
            case 'Finalizada':
                return 'success'
            case 'En proceso':
                return 'primary'
            case 'Asignar':
                return 'default'
            default:
                return 'warning'
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 3, p: 1,  width: '30vw', maxHeight: '90vh', overflowY: 'auto'}
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                    <Typography variant="h6" fontWeight="bold" color="primary">
                        Detalle de OT #{otNumber}
                    </Typography>
                    {report.state && (
                        <Chip
                            label={report.state}
                            color={getStatusColor(report.state)}
                            size="small"
                            sx={{ fontWeight: 'bold' }}
                        />
                    )}
                </Box>
                <IconButton onClick={handleClose} size="small">
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid>
                    <Grid>
                        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%', bgcolor: '#fafafa' }}>
                            <Typography variant="subtitle2" color="primary" fontWeight="bold" gutterBottom>
                                Información General
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                <Typography variant="body2">
                                    <strong>N° OT:</strong> {otNumber}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>ID SAP:</strong> {report.sapId || 'No asignado'}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>SPM:</strong> {report.idPm || report.guide || 'N/A'}
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Progreso:</strong> {report.progress ?? 0}%
                                </Typography>
                                <Typography variant="body2">
                                    <strong>Hallazgos:</strong> {report.hallazgosCount ?? report.backlogCount ?? 0}
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Box display="flex" gap={1}>
                    {Boolean(report.urlPdf) && (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleViewPdf}
                        >
                            Ver PDF
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            handleClose()
                            navigate(`/assignment/${otNumber}`)
                        }}
                    >
                        Ver Reporte
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

export default ReportDetailDialog
